export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/path1ThankYou.96634849.svg","height":231,"width":339,"blurWidth":0,"blurHeight":0};